<div class="layer-container" *ngIf="mapControls$ | async as mapControls">
  <div class="map-style-box" [ngClass]="currentMapStyle" (click)="toggleMapControlsEvent('switchMapMode')">
    <div class="map-style-box-inner">
      <div class="map-label">
        {{ currentMapStyle === 'SATELLITE' ? 'Topo' : 'Satellite' }}
      </div>
      <div class="label">
        <fa-icon [icon]="['fal', 'layer-group']"></fa-icon>
        Layers
      </div>
    </div>
  </div>
  <div class="layer-box">
    <div class="layer-inner-container">
      @if (mapControls.displayKMLUpload !== null) {
        <div class="layer">
          <div data-cy="kml-layer-select" class="layer-image" [class]="mapControls.displayKMLUpload ? 'selected' : ''"
               (click)="toggleMapControlsEvent('displayKMLUpload')">
            <img src="../../../../assets/KML.png" alt="KML" />
          </div>
          <div class="layer-label">
            KML

          </div>
        </div>
      }
      @if (this.standMap) {
        <div class="layer">
          <div class="layer-image" [class]="mapControls.suggestedStandsSelector ? 'selected' : ''"
               (click)="toggleMapControlsEvent('suggestedStandsSelector')">
            <img src="../../../../assets/Stands.png" alt="Stands" />
          </div>
          <div class="layer-label">
            Stands

          </div>
        </div>
        <div class="layer">
          <div class="layer-image" [class]="mapControls.displayStands ? 'selected' : ''"
               (click)="toggleMapControlsEvent('displayStands')">
            <img src="../../../../assets/Included.png" alt="Included" />
          </div>
          <div class="layer-label">
            Included
          </div>
        </div>
        <div class="layer">
          <div class="layer-image" [class]="mapControls.displayForest ? 'selected' : ''"
               (click)="toggleMapControlsEvent('displayForest')">
            <img src="../../../../assets/Forest.png" alt="Forest" />
          </div>
          <div class="layer-label">
            Forest
          </div>
        </div>
        @if (isAdmin) {
          <div class="layer">
            <div class="layer-image" [class]="mapControls.displayPublicLand ? 'selected' : ''"
                 (click)="toggleMapControlsEvent('displayPublicLand')">
              <img src="../../../../assets/Redflag.png" alt="Red Flag" />
            </div>
            <div class="layer-label">
              Redflag
            </div>
          </div>
        }
      }
      <div class="layer">
        <div class="layer-image" [class]="mapControls.displayWaterways ? 'selected' : ''"
             (click)="toggleMapControlsEvent('displayWaterways')">
          <img src="../../../../assets/Water.png" alt="Water" />
        </div>
        <div class="layer-label">
          Water
        </div>
      </div>
      <div class="layer">
        <div class="layer-image" [class]="mapControls.displayRoads ? 'selected' : ''"
             (click)="toggleMapControlsEvent('displayRoads')">
          <img src="../../../../assets/Roads.png" alt="Roads" />
        </div>
        <div class="layer-label">
          Roads
        </div>
      </div>
    </div>
  </div>
</div>
